import script from "./BottomNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNavbar.vue?vue&type=script&setup=true&lang=js"

import "./BottomNavbar.vue?vue&type=style&index=0&id=d8835352&lang=scss"

const __exports__ = script;

export default __exports__